// Terms of Use: parsing helpers shared by the server, the member app and tests.
// The text itself lives in src/content/terms.md and is bundled as a string by
// src/core/terms-text.ts (esbuild `.md` text loader; vitest.config.mjs in tests).

/** The version id from the "Version <id>" line, e.g. "2026-09-28". Empty when missing. */
export function parseTermsVersion(md: string): string {
  const m = /^Version\s+(\S+?)(?=\s|$)/m.exec(md);
  return m ? m[1] : '';
}

/** True while the "Version" line still says DRAFT. */
export function termsIsDraft(md: string): boolean {
  const line = /^Version\s+.*$/m.exec(md)?.[0] ?? '';
  return /\bDRAFT\b/.test(line);
}

/** One recorded acceptance. Appended to Member.termsHistory, never overwritten. */
export interface TermsAcceptance {
  version: string;
  /** ISO timestamp */
  acceptedAt: string;
  via: 'onboarding' | 'update';
}

/** Practitioner console line: "Terms: agreed to <version> on <date>" or "Terms: Not yet agreed". */
export function termsStatusText(a: Pick<TermsAcceptance, 'version' | 'acceptedAt'> | null | undefined, locale?: string): string {
  if (!a) return 'Terms: Not yet agreed';
  const date = new Date(a.acceptedAt).toLocaleDateString(locale, { year: 'numeric', month: 'short', day: 'numeric' });
  return `Terms: agreed to ${a.version} on ${date}`;
}
